import { CoBrands } from 'src/enums'
import {
  faqUrl,
  featureFlaggerUrl,
  privacyUrl,
  supportRequestUrl,
  supportUrl,
  termsUrl,
} from 'src/navigation/urls'

export const noRedirectURLs = [
  termsUrl(),
  faqUrl(),
  privacyUrl(),
  supportUrl(),
  supportRequestUrl(),
  featureFlaggerUrl(),
]

export const CONFIRM_DEACTIVATE_USER_TEXT = 'DEACTIVATE'
export enum ConfirmDeactivateUserText {
  'fr-CA' = 'DÉSACTIVER',
  'en-CA' = 'DEACTIVATE',
  'en-US' = 'DEACTIVATE',
}

export const CONFIRM_CLOSE_CARD_TEXT = 'CLOSE'
export enum ConfirmCloseCardText {
  'fr-CA' = 'FERMER',
  'en-CA' = 'CLOSE',
  'en-US' = 'CLOSE',
}

export const CONFIRM_DOWNGRADE_SUBSCRIPTION_TEXT = 'DOWNGRADE'
export enum ConfirmDowngradeSubscriptionText {
  'fr-CA' = 'RÉTROGRADER',
  'en-CA' = 'DOWNGRADE',
  'en-US' = 'DOWNGRADE',
}

export const CONFIRM_DELETE_API_KEY_TEXT = 'DELETE'
export enum ConfirmDeleteApiKeyText {
  'fr-CA' = 'SUPPRIMER',
  'en-CA' = 'DELETE',
  'en-US' = 'DELETE',
  'en-GB' = 'DELETE',
}

export const getDeviceType = (): string => {
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    const userAgentParts = navigator.userAgent.split(/[()]/)
    if (userAgentParts.length > 1) {
      return userAgentParts[1].replace(/;/g, '')
    }
  }
  return ''
}

export const CoBrandAbbreviations: { [key in CoBrands]: string } = {
  [CoBrands.Bmo]: 'BMO',
  [CoBrands.Pnc]: 'PNC',
}

export const CoBrandFullNames: { [key in CoBrands]: string } = {
  [CoBrands.Pnc]: 'PNC Bank',
  [CoBrands.Bmo]: 'Bank of Montreal',
}
